<template>
    <div class="h-100">
        <edit-switch :tab="selectedTab" :edit="editEnabled" :initialCondition="selectedTab == 4" v-on:toggleEdit="handleToggleEdit" />
        <conditional-text :condition="selectedTab === 4 && courseDetails.chapters.length < 1" text="No content yet" />
        <div v-for="(chapter, idx) in courseDetails.chapters"
             v-show="selectedTab == 4 && selectedChapter == idx"
             class="tab-content">
            <div class="item-content">
                <div class="access-sg text clearfix">

                    <div class="d-flex justify-content-between align-items-center">
                        <div class="container text-wrap">
                            <h2>{{chapter.name == "" ? "New Module" : chapter.name}}</h2>
                        </div>
                    </div>

                    <div class="flat-tabs" style="margin-bottom: 0px; padding-bottom: 0px;">
                        <div class="tab-content-wrap">
                            <div v-for="(page, pageIdx) in chapter.pages"
                                 v-show="selectedPage == pageIdx" class="tab-content p-0">
                                <div class="item-content">
                                    <div class="cms-course-wrapper-1">
                                        <div class="pl-2 text-sea-blue">
                                            <h2>{{page.name}}</h2>
                                        </div>
                                        <div v-show="hasQuestions( null, page)">
                                            <div v-show="editEnabled">
                                                <label>Minimum Percentage Pass Mark</label>
                                                <input v-model.number="page.minimumPercentagePassMark" class="page-passmark" :id="'pm-ch-' + idx + 'p-' + pageIdx" type="number" />
                                            </div>
                                            <div v-show="editEnabled">
                                                <label>Percentage Weight</label>
                                                <input v-model.number="page.percentageWeight" class="page-weight" :id="'pw-ch-' + idx + 'p-' + pageIdx" type="number" />
                                            </div>
                                            <div v-show="editEnabled">
                                                <div class="d-flex align-items-center mt-2">
                                                    <label>Choose </label>
                                                    <input v-model.number="page.randomSelection" type="number" class="form-control ml-2 mr-2" style="max-width: 80px;" />
                                                    <label> random questions</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="editEnabled" class="d-flex justify-content-between" style="border-bottom: 1px solid #3d3c79;">
                                            <h2 class="pl-2">Components:</h2>
                                            <div class="cms-btn-wrapper pb-0 d-flex justify-content-end" style="padding-right: 30px;">
                                                <button type="button" class="btn btn-add-alt" v-on:click="$emit('handleAddComponent', page)">
                                                    <i class="fa fa-2x fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div v-if="page.components.length < 1" class="container">
                                            <label>
                                                No components yet! <span v-if="editEnabled"><br />Toggle edit mode on to add new components</span>
                                            </label>
                                        </div>
                                        <!--edit page and components-->
                                        <component-list :initialPage="page" :edit="editEnabled" v-on="$listeners" />


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ContentDisplay",
        props: ["initialCourseDetails", "tab", "chapter", "page", "edit"],
        data() {
            return {
                courseDetails: this.initialCourseDetails,
                selectedTab: this.tab,
                selectedChapter: this.chapter,
                selectedPage: this.page,
                editEnabled: this.edit,
            }
        },
        watch: {
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            },
            tab: function (newVal, oldVal) {
                this.selectedTab = newVal;
            },
            chapter: function (newVal, oldVal) {
                this.selectedChapter = newVal;
            },
            page: function (newVal, oldVal) {
                this.selectedPage = newVal;
            },
            initialCourseDetails: function (newVal, oldVal) {
                this.courseDetails = newVal;
            },
        },
        methods: {
            hasQuestions(event, page) {
                var hasQuestOrScorm = false;
                for (var i = 0; i < page.components.length; i++) {
                    var comp = page.components[i];

                    if (comp.type === "question" || comp.type === "scorm") {
                        hasQuestOrScorm = true;
                        break;
                    }
                }
                return hasQuestOrScorm;
            },
            handleToggleEdit(){
                this.$emit("toggleEdit");
            }
        },
        mounted() {
            //console.log("Chapter pages loaded");
        }
    }
</script>